import { render, staticRenderFns } from "./QuizAnswers.vue?vue&type=template&id=74ede590&"
import script from "./QuizAnswers.vue?vue&type=script&lang=js&"
export * from "./QuizAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports